var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-container-google-2"}},[_c('iframe',{attrs:{"src":"https://maps.google.com/maps?q=Salia+Silesia&t=&z=13&ie=UTF8&iwloc=&output=embed","frameborder":"0"}})])
}]

export { render, staticRenderFns }